import React from 'react'

import { Button, Table, Modal, Form, Col, Row } from '_zari/core'

import * as ActivosFijosService from 'services/activosFijos.service'

const NOMBRES_TIPO = {
  REPO: 'REPOTENCIACION',
  MEJO: 'MEJORA',
  TRAS: 'TRASLADO'
}

const formatFecha = fecha => {
  if (!fecha) return '-'
  const d = new Date(fecha)
  return d.toLocaleDateString('es-PE', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

// Historial de los flujos posteriores del activo. La baja tiene su propia vista.
const MovimientosActivoModal = ({ handleClose, show, activo }) => {
  const [movimientos, setMovimientos] = React.useState([])

  React.useEffect(() => {
    ActivosFijosService.getMovimientos(activo._id)
      .then(({ data }) => setMovimientos(data || []))
      .catch(() => setMovimientos([]))
  }, [activo._id])

  const detalleMovimiento = row => {
    if (row.tipo === 'TRAS') {
      const origen = row.oficinaOrigen || '--'
      const destino = row.oficinaDestino || '--'
      const responsable = row.usuarioEntregadoANuevoNombre
      return `${origen} → ${destino}${responsable ? ` (${responsable})` : ''}`
    }

    const valores = `${row.valorAnterior != null ? row.valorAnterior : '-'} → ${row.valorNuevo != null ? row.valorNuevo : '-'}`
    const dep =
      row.depreciacionAnualNueva != null
        ? ` | deprec. ${row.depreciacionAnualAnterior}% → ${row.depreciacionAnualNueva}%`
        : ''
    return `${valores}${dep}`
  }

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>MOVIMIENTOS DEL ACTIVO</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={4}>
            <Form.Group>
              <Form.Label text='CODIGO' md={12} />
              <Col md={12}>
                <Form.InputText id='readonly-mov-codigo' disabled defaultValue={activo.codigo} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={8}>
            <Form.Group>
              <Form.Label text='DESCRIPCION' md={12} />
              <Col md={12}>
                <Form.InputText id='readonly-mov-descripcion' disabled defaultValue={activo.descripcion} />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Table
          useNest={true}
          maxRowsShown={6}
          headRows={[
            { label: 'FECHA' },
            { label: 'TIPO' },
            { label: 'DESCRIPCION' },
            { label: 'MONTO' },
            { label: 'DETALLE' },
            { label: 'SUSTENTO' }
          ]}
          filas={movimientos}
          rowTemplate={(row, k) => (
            <Table.Row key={k}>
              <Table.Cell>{formatFecha(row.fecha)}</Table.Cell>
              <Table.Cell>{NOMBRES_TIPO[row.tipo] || row.tipo}</Table.Cell>
              <Table.Cell>{row.descripcion || '-'}</Table.Cell>
              <Table.Cell>{row.monto ? row.monto : '-'}</Table.Cell>
              <Table.Cell>{detalleMovimiento(row)}</Table.Cell>
              <Table.Cell>{row.documentoSustento || '-'}</Table.Cell>
            </Table.Row>
          )}
        />
        {movimientos.length === 0 && (
          <div className='text-muted small mt-2'>El activo no registra movimientos posteriores.</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default MovimientosActivoModal
